module.exports = __webpack_public_path__ + "img/leftthigh-ecto-mesomorph-female.7e3b45a6.svg";